// Bridges the ticket message list's "ask Cortex about this message" button
// (frontend/src/components/Chat/MessagesArea/ChatWindow/MessageItem) to the
// sidebar Cortex chat component.
//
// Two cases:
//  - The sidebar isn't mounted yet (opening it is an async React state
//    update) - the question is stashed here and picked up once the sidebar
//    mounts and registers for that ticket.
//  - The sidebar is *already* mounted and open for this ticket (e.g. the
//    operator clicks the button a second time without closing it) - nothing
//    would otherwise re-check the mailbox, since nothing about the sidebar's
//    own state changes on a repeat click. A live listener lets the button
//    hand the question straight to the already-mounted surface instead.
let pending = null
let listener = null

export const setPendingQuickAsk = (uniqueId, text) => {
    if (!uniqueId || !text) return

    if (listener && listener.uniqueId === uniqueId) {
        listener.onMessage(text)
        return
    }

    pending = { uniqueId, text }
}

export const consumePendingQuickAsk = (uniqueId) => {
    if (pending && uniqueId && pending.uniqueId === uniqueId) {
        const { text } = pending
        pending = null
        return text
    }
    return null
}

export const registerQuickAskListener = (uniqueId, onMessage) => {
    listener = uniqueId ? { uniqueId, onMessage } : null
}

export const unregisterQuickAskListener = (uniqueId) => {
    if (listener && listener.uniqueId === uniqueId)
        listener = null
}
